(() => {
 function connect(root) {
  const el=root.matches?.('slideshow-component')?root:root.querySelector?.('slideshow-component');
  if(!el || !el.querySelector('.kuk-commercial')) return;
  let attempts=0;
  const attach=()=>{
   const f=el.flickity;
   if(!f){if(++attempts<100)setTimeout(attach,100);return;}
   if(el.dataset.kukCommercialConnected==='true')return;
   el.dataset.kukCommercialConnected='true';
   f.options.adaptiveHeight=true;
   const resize=()=>{f.resize();f.setGallerySize();};
   f.on('select',()=>requestAnimationFrame(()=>f.setGallerySize()));
   el.querySelectorAll('.kuk-commercial img').forEach(img=>img.addEventListener('load',resize,{once:true}));
   resize();
  };attach();
 }
 const init=()=>document.querySelectorAll('slideshow-component').forEach(connect);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',event=>connect(event.target));
})();
